import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import chroma from 'chroma-js';
import { Component } from 'react';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { propAny, propArrayShape, propBool, propFunc, propShape, propStr, propChildren, } from '../../../../../helpers/custom-prop-types';
class RawSelect2Fields extends Component {
    constructor(props) {
        super(props);
        const { components } = props;
        this.animatedComponents = Object.assign(Object.assign({}, makeAnimated()), components);
        this.defaultStyles = {
            control: (styles, args) => {
                const { isFocused } = args;
                const borderColor = '#C4C4C4';
                return Object.assign(Object.assign({}, styles), { backgroundColor: 'white', borderBottom: isFocused ? 'none' : '1px solid', borderColor: `${borderColor} !important`, borderLeft: 'none', borderRadius: 0, borderRight: 'none', borderTop: 'none', boxShadow: 'none' });
            },
            indicatorSeparator: () => ({
                display: 'none',
            }),
            menu: (styles) => (Object.assign(Object.assign({}, styles), { border: '1px solid #C4C4C4', boxShadow: 'none', marginTop: 0, zIndex: 1020 })),
            menuList: (styles) => (Object.assign(Object.assign({}, styles), { paddingBottom: 0, paddingTop: 0 })),
            menuPortal: (styles) => (Object.assign(Object.assign({}, styles), { zIndex: 1020 })),
            option: (styles, args) => {
                const { data, isFocused, isSelected } = args;
                const color = chroma(data.color);
                let backgroundColor = null;
                if (isSelected) {
                    backgroundColor = data.color;
                }
                else if (isFocused) {
                    backgroundColor = color.alpha(0.1).css();
                }
                let setColor;
                if (isSelected) {
                    setColor = chroma.contrast(color, 'white') > 2 ? 'white' : 'black';
                }
                else {
                    setColor = data.color;
                }
                return Object.assign(Object.assign({}, styles), { ':active': Object.assign(Object.assign({}, styles[':active']), { backgroundColor: isSelected ? data.color : color.alpha(0.3).css() }), backgroundColor, color: setColor, cursor: 'default' });
            },
        };
    }
    render() {
        const { blurInputOnSelect, className, classNamePrefix, defaultValue, inputRef, isDisabled, isMulti, isSearchable, menuIsOpen, menuPortalTarget, menuPosition, name, onBlur, onChange, onFocus, options, placeholder, value, } = this.props;
        return (_jsx(Select, { blurInputOnSelect: blurInputOnSelect, className: className, classNamePrefix: classNamePrefix, components: this.animatedComponents, defaultValue: defaultValue, isDisabled: isDisabled, isMulti: isMulti, isSearchable: isSearchable, menuIsOpen: menuIsOpen, menuPortalTarget: menuPortalTarget, menuPosition: menuPosition, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, options: options, placeholder: placeholder, ref: inputRef, styles: this.defaultStyles, value: value }));
    }
}
RawSelect2Fields.propTypes = {
    blurInputOnSelect: propBool(),
    className: propStr(),
    classNamePrefix: propStr(),
    components: propShape(),
    defaultValue: propAny(),
    inputRef: propShape(),
    isDisabled: propBool(),
    isMulti: propBool().isRequired,
    isSearchable: propBool(),
    menuIsOpen: propBool(),
    menuPortalTarget: propChildren(),
    menuPosition: propStr(),
    name: propStr().isRequired,
    onBlur: propFunc(),
    onChange: propFunc().isRequired,
    onFocus: propFunc(),
    options: propArrayShape().isRequired,
    placeholder: propStr().isRequired,
    value: propAny(),
};
RawSelect2Fields.defaultProps = {
    blurInputOnSelect: undefined,
    className: undefined,
    classNamePrefix: undefined,
    components: undefined,
    defaultValue: undefined,
    inputRef: undefined,
    isDisabled: false,
    isSearchable: true,
    menuIsOpen: undefined,
    menuPortalTarget: undefined,
    menuPosition: undefined,
    onBlur: undefined,
    onFocus: undefined,
    value: undefined,
};
export default RawSelect2Fields;
